import React, { useEffect, useMemo, useState } from "react";
import { Card, Spinner, Alert } from "react-bootstrap";

import KpiSection from "../../dashboard/components/KpiSection";
import { KPI_ICONS } from "../../dashboard/constants/kpiIcons";
import { KPI_COLORS } from "../../dashboard/constants/kpiColors";
import DashboardService from "../../../services/pbumku/DashboardService";
import { usePeriode } from "../context/PeriodeContext";

export default function ReportPrimer() {
  const DashService = useMemo(() => new DashboardService(), []);
  const { periode } = usePeriode();
  const { startDate, endDate } = periode;
  const yearPeriod = startDate ? startDate.split("-")[0] : new Date().getFullYear();

  const [rekapPrimer, setRekapPrimer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRekapPrimer = async () => {
      if (!startDate || !endDate) return;

      try {
        setLoading(true);
        setError(null);

        // Primer menggunakan format YYYY-MM-DD dari filter global.
        const response = await DashService.getRekapPermohonan(
          startDate,
          endDate
        );

        const result =
          response?.data?.rekap ??
          response?.data?.data ??
          response?.data ??
          {};

        setRekapPrimer(result);
      } catch (err) {
        console.error("Fetch rekap primer error:", err);

        setError(
          err?.response?.data?.message ||
            err?.message ||
            "Gagal mengambil data rekap Sertifikasi Mutu Primer."
        );

        setRekapPrimer(null);
      } finally {
        setLoading(false);
      }
    };

    fetchRekapPrimer();
  }, [DashService, startDate, endDate]);

  return (
    <Card className="shadow-sm rounded-3 mb-3 border-0">
      <Card.Body>
        <div className="mb-4">
          <h6 className="fw-bold text-uppercase mb-1">
            Rekap Sertifikasi Mutu Primer
          </h6>

          <small className="text-muted">
            Periode Tahun {yearPeriod}
          </small>
        </div>

        {loading && (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ minHeight: "150px" }}
          >
            <div className="text-center">
              <Spinner animation="border" size="sm" className="me-2" />
              <span className="text-muted">Memuat data...</span>
            </div>
          </div>
        )}

        {!loading && error && (
          <Alert variant="danger" className="mb-0">
            {error}
          </Alert>
        )}

        {!loading && !error && (
          <KpiSection
            rekap={rekapPrimer || {}}
            loading={loading}
            icons={KPI_ICONS}
            colors={KPI_COLORS}
          />
        )}
      </Card.Body>
    </Card>
  );
}
